import { defineMessages } from 'react-intl';

export const languagesTranslations = defineMessages({
    atLeastOne: {
        id: 'Languages.form.validation.atLeastOne',
        defaultMessage: 'Fill at least one language'
    }
});
